<template>
  <div class="scontainer">
    <div class="header">
      <div class="date">
        <div>{{nDate}}</div>
        <div>{{nTime}} </div>
        <div>{{nDay}}</div>
      </div>
      <div class="title">
        <img src="../../assets/img/h.png" />
      </div>

      <div id="weater" class="weather">
        <div id="weather-v2-plugin-simple"></div>
        <remote-script src="https://apip.weatherdt.com/simple/static/js/weather-simple-common.js?v=2.0"></remote-script>
      </div>

    </div>
    <el-row>
      <el-col :span="6" class="cleft">
        <div class="chongzhi">
          <div class="chbox">
            <div class="ctitle">每月充值总量</div>
            <div class="cavasbox" ref="fengLei"></div>
          </div>
        </div>
        <div class="meiyue">
          <div class="chbox">
            <div class="ctitle">每月用量总计</div>
            <div class="cavasbox" ref="yongl"></div>
          </div>
        </div>
        <div class="meiri">
          <div class="chbox">
            <div class="ctitle">每日用量总计</div>
            <div class="cavasbox" ref="meiri"></div>
          </div>

        </div>
      </el-col>
      <el-col :span="12">
        <div class="dataList">
          <div class="dataItem">
            <div class="img"><img src="../../assets/img/d1.png" /></div>
            <div class="num" style="color: #9385FC;">{{usersNum}}</div>
            <div class="title">用户总数</div>
          </div>
          <div class="dataItem">
            <div class="img"><img src="../../assets/img/d2.png" /></div>
            <div class="num" style="color: #4CD964;">{{powerMoney}}</div>
            <div class="title">电费总数(万元)</div>
          </div>
          <div class="dataItem">
            <div class="img"><img src="../../assets/img/d3.png" /></div>
            <div class="num" style="color: #F7D90E;">{{waterMoney}}</div>
            <div class="title">水费总数(万元)</div>
          </div>
          <div class="dataItem">
            <div class="img"><img src="../../assets/img/d4.png" /></div>
            <div class="num" style="color: #00A3F8;">{{meterNum}}</div>
            <div class="title">设备总览</div>
          </div>
          <div class="dataItem">
            <div class="img"><img src="../../assets/img/d5.png" /></div>
            <div class="num" style="color:#DD691A">{{goaJinNum}}</div>
            <div class="title">告警总数</div>
          </div>
        </div>
        <div class="map" ref="map"></div>
      </el-col>
      <el-col :span="6" class="cleft">
        <div class="yongtu">
          <div class="switch">
            <el-radio-group v-model="ntype" size="mini" @change="getYongTu">
              <div style="margin-bottom: 14px;"><el-radio :label="15" style="color: #fff;">电</el-radio></div>
              <div style="margin-bottom: 14px;"><el-radio :label="16" style="color: #FAEE04;">水</el-radio></div>
              <div><el-radio :label="18" style="color: #F56C6C;">热能</el-radio></div>
            </el-radio-group>
          </div>
          <div class="ctitle">能源用途总量</div>

          <div class="cavasbox" ref="yongtu"></div>
        </div>

        <div class="rili">
          <div class="ctitle">用能日历</div>
          <div class="riliBox">
            <el-calendar v-model="cdate">
              <template slot="dateCell" slot-scope="{date, data}">
                <span style="display: block;" @click="getDate(data)">{{ data.day.substring(8)}}</span>
              </template>
            </el-calendar>
          </div>
          <div class="tongji">
            <div class="titem">
              <p>电日用量(万千瓦时)</p>
              <div class="tdata">{{powerValue}}</div>
            </div>
            <div class="titem">
              <p>水日用量(万立方米)</p>
              <div class="tdata">{{waterValue}}</div>
            </div>
            <div class="titem">
              <p>热能(万立方米)</p>
              <div class="tdata">{{hotValue}}</div>
            </div>
          </div>
        </div>

      </el-col>
    </el-row>
  </div>
</template>


<script>
  window.WIDGET = {
    CONFIG: {
      "modules": "01234",
      "background": 5,
      "tmpColor": "FFFFFF",
      "tmpSize": 16,
      "cityColor": "FFFFFF",
      "citySize": 16,
      "aqiSize": 16,
      "weatherIconSize": 24,
      "alertIconSize": 18,
      "padding": "10px 10px 10px 10px",
      "shadow": "1",
      "language": "auto",
      "borderRadius": 5,
      "fixed": "false",
      "vertical": "middle",
      "horizontal": "center",
      "key": "GZD5HBtJ8j"
    }
  };
  
  
  


  import Vue from 'vue'
  Vue.component('remote-script', { // vue动态生成script (在html中当成组件来用)
    render: function(createElement) {
      var self = this;
      return createElement('script', {
        attrs: {
          type: 'text/javascript',
          src: this.src
        },
        on: {
          load: function(event) {
            self.$emit('load', event);
          },
          error: function(event) {
            self.$emit('error', event);
          },
          readystatechange: function(event) {
            if (this.readyState == 'complete') {
              self.$emit('load', event);
            }
          }
        }
      });
    },
    props: {
      src: {
        type: String,
        required: true
      }
    }
  })



  import Chart from 'echarts'
  import {
    timestampToTime
  } from '../../utils/util'
  import '../../../node_modules/echarts/map/js/china.js'
  import {
    findAccoutMoneySum,
    findEnergyTotalByYearDate,
    getAllUnUpdateMeterInfoTotal,
    findAppletUserSum,
    findAccoutMoneyTotal,
    findFacilitySum,
    getEnergyByEnergyType,
    EnergyRecordYtListNew,
    findEnergyTotalByMonthDate,
    findProvinceUserTotal
  } from '../../api/summaryMG.js'
  export default {
    data() {
      return {

        goaJinNum: 0,
        usersNum: 0,
        powerMoney: 0,
        waterMoney: 0,
        meterNum: 0,
        date: "",
        powerValue: 0,
        waterValue: 0,
        hotValue:0,
        cdate: new Date() - 24 * 60 * 60 * 1000,
        ntype: 15,


        nDate: new Date(),
        nTime: "",
        nDay: ""

      }
    },
    created() {
      this.gaoJin()
      this.getUsers()
      this.Recharge(15)
      this.Recharge(16)
      this.getMeterNum()
      this.date = timestampToTime(this.cdate).substring(0, 10)
      this.nDate = timestampToTime(new Date()).substring(0, 10)
      this.getRili()

      let weekDay = [
        "星期天",
        "星期一",
        "星期二",
        "星期三",
        "星期四",
        "星期五",
        "星期六"
      ];
      this.nDay = weekDay[new Date().getDay()]

    },
    mounted() {
      this.getChongZhi()
      this.getYongLiang()
      this.getYongTu()
      this.chinaConfigure()
      this.getMeiRiData()

      let _this = this; // 声明一个变量指向Vue实例this，保证作用域一致

        this.timer = setInterval(() => {
            let d = new Date()
           let hh =d.getHours() < 10? "0" + d.getHours(): d.getHours();
           let mm =d.getMinutes() < 10? "0" + d.getMinutes(): d.getMinutes();
           let ss =d.getSeconds() < 10? "0" + d.getSeconds(): d.getSeconds();

           _this.nTime = hh+':'+mm+':'+ss

      }, 1000)

    },
     beforeDestroy() {
        if (this.timer) {
          clearInterval(this.timer); // 在Vue实例销毁前，清除我们的定时器
        }
      },
    methods: {


      getDate(val) {
        this.date = val.day

        this.getRili()
        //this.getDataByDate()
      },

      getMeiRiData() {
        findEnergyTotalByMonthDate().then(res => {
          if (res.status == 1) {
            let option = {
              tooltip: {
                trigger: 'axis'
              },
              legend: {
                data: [{
                    name: '电(万千瓦时)',
                    icon: 'circle',
                    textStyle: {
                      color: '#fff'
                    }
                  },
                  {
                    name: "水(万立方米)",
                    icon: 'circle',
                    textStyle: {
                      color: '#fff'
                    }
                  },
                  {
                    name: "热能(万立方米)",
                    icon: 'circle',
                    textStyle: {
                      color: '#fff'
                    }
                  },
                ],
                textStyle: {
                  color: '#fff'
                },
              },

              grid: {
                left: '3%',
                right: '4%',
                bottom: '3%',
                top: '14%',
                containLabel: true
              },
              toolbox: {
                show: true,
              },
              calculable: true,
              xAxis: [{

                type: 'category',
                data: res.data.dateList,
                axisLine: {
                  lineStyle: {
                    color: '#fff'
                  }
                },
              }],
              yAxis: [{
                  type: 'value',
                  axisLabel: {
                    formatter: '{value}',
                    textStyle: {
                      color: '#fff'
                    },
                    lineStyle: {
                      color: '#fff'
                    }
                  }
                },

              ],

              series: [{
                  name: '电(万千瓦时)',
                  type: 'bar',
                  data: res.data.powerMoneyList,

                  itemStyle: {
                    normal: {
                      color: new Chart.graphic.LinearGradient(0, 0, 0, 1, [{
                        offset: 0,
                        color: '#06C5F5',
                      }, {
                        offset: 1,

                        color: '#7C04ED'
                      }]),
                    }
                  },
                  label: {
                    show: false,
                    position: 'top',
                    color: "#2AAEF2"
                  }
                },
                {
                  name: '水(万立方米)',
                  type: 'line',
                  symbolSize: 8,
                  data: res.data.waterMoneyList,

                  color: ['#FAEE04']

                },
                {
                  name: '热能(万立方米)',
                  type: 'line',
                  symbolSize: 8,
                  data: res.data.hotMoneyList,
                  // data: [1,2,3,4,5,6,7,3,4,5,6,4,2,23,21,33,22,44,21,22],
                  color: ['#F56C6C']

                },


              ]
            }

            this.chart = Chart.init(this.$refs.meiri)
            this.chart.setOption(option)
          }
        })
      },

      getRili() {

        getEnergyByEnergyType({
          date: this.date
        }).then(res => {
          if (res.status == 1) {
            this.powerValue = res.data.powerDay
            this.waterValue = res.data.waterDay
            this.hotValue = res.data.hotDay
          }
        })
      },
      getMeterNum() {
        findFacilitySum().then(res => {
          if (res.status == 1) {
            this.meterNum = res.data
          }
        })
      },
      gaoJin() {
        getAllUnUpdateMeterInfoTotal().then(res => {
          if (res.status == 1) {
            this.goaJinNum = res.data.size
          }
        })
      },

      Recharge(type) {
        findAccoutMoneyTotal({
          energyType: type
        }).then(res => {
          if (res.status == 1) {
            if (type == 15) {
              this.powerMoney = res.data.money || 0
            } else {
              this.waterMoney = res.data.money || 0
            }
          }
        })
      },

      getUsers() {
        findAppletUserSum().then(res => {
          if (res.status == 1) {
            this.usersNum = res.data
          }
        })
      },


      chinaConfigure() {
        findProvinceUserTotal().then(res => {
          if (res.status == 1) {
            var convertData = function(data) {
              var res = [];
              for (var i = 0; i < data.length; i++) {
                var geoCoord = geoCoordMap[data[i].name];
                if (geoCoord) {
                  res.push({
                    name: data[i].name,
                    value: geoCoord.concat(data[i].value)
                  });
                }
              }
              console.log(res)
              return res;
            };


            let option = {
              tooltip: {
                trigger: 'item'
              },
              legend: {
                show: false,
                orient: 'vertical',
                left: 'left',
                data: ['用户数']
              },


              visualMap: {
                min: 0,
                max: 1500,
                left: 'left',
                top: 'bottom',
                text: ['高', '低'],
                inRange: {
                  color: ['#df0717', '#23d8ea', '#e49214']
                },
                show: false
              },
              tooltip: {
                        trigger: 'item',
                        formatter: function (params) {
                          if(typeof(params.value)[2] == "undefined"){
                            return params.name + ' : ' + params.value;
                          }else{
                            return params.name + ' : ' + params.value[2];
                          }
                        }
                    },

              grid: {
                right: '1%',
                top: '1%',
                bottom: '10%',
                width: '30%'
              },
              geo: {
                zoom: 1.2,
                map: 'china', // 表示中国地图
                roam: true,
                label: {
                  normal: {
                    show: false,
                    fontSize: '10',
                    color: 'rgba(0,0,0,0.7)'
                  },
                  emphasis: {
                    show: true
                  }
                },

                itemStyle: {

                  normal: {
                    borderColor: 'rgba(147, 235, 248, 1)',
                    borderWidth: 1,
                    areaColor: {
                      type: 'radial',
                      x: 0.5,
                      y: 0.5,
                      r: 0.8,
                      colorStops: [{
                        offset: 0,
                        color: 'rgba(147, 235, 248, 0)' // 0% 处的颜色
                      }, {
                        offset: 1,
                        color: 'rgba(147, 235, 248, .2)' // 100% 处的颜色
                      }],
                      globalCoord: false // 缺省为 false
                    },
                    shadowColor: 'rgba(128, 217, 248, 1)',

                    shadowOffsetX: -2,
                    shadowOffsetY: 2,
                    shadowBlur: 10

                  },
                  emphasis: {
                    shadowOffsetX: 0,
                    shadowOffsetY: 0,
                    shadowBlur: 20,
                    borderWidth: 0,
                    shadowColor: 'rgba(0, 0, 0, 0.5)'
                  },
                },

              },


              series: [{

                  type: 'effectScatter',
                  coordinateSystem: 'geo',
                  data: res.data,
                  symbolSize: 6,
                  showEffectOn: 'render',
                  zlevel: 2,
                  rippleEffect: {
                    period: 2.5, //波纹秒数
                    brushType: 'fill', //stroke(涟漪)和fill(扩散)，两种效果
                    scale: 15 //波纹范围
                  },
                  hoverAnimation: true,
                  label: {
                    normal: {
                      formatter: '{b}',
                      position: 'top',
                      show: true
                    }
                  },
                  itemStyle: {
                    normal: {
                      show: true,
                      color: "#0579FA", //字体和点颜色
                      label: {
                        textStyle: {
                          fontSize: 12, //字体大小
                          color: "#fff"
                        }
                      },
                    }
                  },

                }

              ]
            }
            this.chart = Chart.init(this.$refs.map); //这里是为了获得容器所在位置
            this.chart.setOption(option)
          }
        })



      },


      getChongZhi() {

        findAccoutMoneySum().then(res => {
          if (res.status == 1) {
            let option = {
              tooltip: {
                trigger: 'axis'
              },
              legend: {
                data: [{
                  name: '电',
                  icon: 'circle',
                  textStyle: {
                    color: '#fff'
                  }
                }, {
                  name: "水",
                  icon: 'circle',
                  textStyle: {
                    color: '#fff'
                  }
                },{
                  name: "热能",
                  icon: 'circle',
                  textStyle: {
                    color: '#fff'
                  }
                }],
                textStyle: {
                  color: '#fff'
                },
              },
              grid: {
                left: '3%',
                right: '4%',
                bottom: '10%',
                top: '18%',
                containLabel: true
              },
              toolbox: {
                show: true,
              },
              calculable: true,
              xAxis: [{
                type: 'category',
                data: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
                axisLine: {
                  lineStyle: {
                    color: '#fff'
                  }
                },
              }],
              yAxis: [{
                  type: 'value',
                  axisLabel: {
                    formatter: '{value}',
                    textStyle: {
                      color: '#fff'
                    },
                    lineStyle: {
                      color: '#fff'
                    }
                  }
                },

              ],
              series: [{
                  name: '电',
                  type: 'line',
                  data: res.data.powerMoneyList,
                  smooth: true,
                  symbolSize: 8,
                  color: ['#00D3FF'],
                },
                {
                  name: '水',
                  type: 'line',
                  data: res.data.waterMoneyList,
                  smooth: true,
                  symbolSize: 8,
                  color: ['#FAEE04'],
                },
                {
                  name: '热能',
                  type: 'line',
                  data: res.data.hotMoneyList,
                  // data: [20,62,14,36,12,66,44,32,12,77,41,34],
                  smooth: true,
                  symbolSize: 8,
                  color: ['#F56C6C'],
                }
              ]
            }
            this.chart = Chart.init(this.$refs.fengLei)
            this.chart.setOption(option)

          }

        })
      },

      getYongLiang() {

        findEnergyTotalByYearDate().then(res => {
          if (res.status == 1) {
            let option = {
              tooltip: {
                trigger: 'axis'
              },
              legend: {
                data: [{
                    name: '电(万千瓦时)',
                    icon: 'circle',
                    textStyle: {
                      color: '#fff'
                    }
                  },
                  {
                    name: "水(万立方米)",
                    icon: 'circle',
                    textStyle: {
                      color: '#fff'
                    }
                  },
                  {
                    name: "热能(万立方米)",
                    icon: 'circle',
                    textStyle: {
                      color: '#fff'
                    }
                  },
                ],
                textStyle: {
                  color: '#fff'
                },
              },

              grid: {
                left: '3%',
                right: '4%',
                bottom: '13%',
                top: '14%',
                containLabel: true
              },
              toolbox: {
                show: true,
              },
              calculable: true,
              xAxis: [{
                type: 'category',
                data: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
                axisLine: {
                  lineStyle: {
                    color: '#fff'
                  }
                },
              }],
              yAxis: [{
                  type: 'value',
                  axisLabel: {
                    formatter: '{value}',
                    textStyle: {
                      color: '#fff'
                    },
                    lineStyle: {
                      color: '#fff'
                    }
                  }
                },

              ],

              series: [{
                  name: '电(万千瓦时)',
                  type: 'bar',
                  data: res.data.powerMoneyList,

                  itemStyle: {
                    normal: {
                      color: new Chart.graphic.LinearGradient(0, 0, 0, 1, [{
                        offset: 0,
                        color: '#06C5F5',
                      }, {
                        offset: 1,

                        color: '#7C04ED'
                      }]),
                    }
                  },
                  label: {
                    show: false,
                    position: 'top',
                    color: "#2AAEF2"
                  }
                },
                {
                  name: '水(万立方米)',
                  type: 'line',
                  symbolSize: 8,
                  data: res.data.waterMoneyList,

                  color: ['#FAEE04']

                },
                {
                  name: '热能(万立方米)',
                  type: 'line',
                  symbolSize: 8,
                  data: res.data.hotMoneyList,
                  // data: [20,62,14,36,12,66,44,32,12,77,41,34],
                  color: ['#F56C6C']

                },


              ]
            }

            this.chart = Chart.init(this.$refs.yongl)
            this.chart.setOption(option)
          }
        })


      },

      getYongTu() {

        let param = {
          energyType: this.ntype,
          dateType: 'year'
        }

        let names = []

        EnergyRecordYtListNew(param).then(res => {
          if (res.status == 1) {
            res.data.data.forEach(item => {
              names.push(item.name)

            })

            let option = {
              tooltip: {
                trigger: 'item',
                formatter: '{a} <br/>{b}: {c} ({d}%)'
              },

              legend: {


                bottom: 1,
                textStyle: {
                  color: "#fff"
                }
              },
              grid: {
                left: '3%',
                right: '4%',
                bottom: '23%',
                top: '24%',
                containLabel: true
              },
              series: [{
                name: "用途",
                type: 'pie',
                radius: ['20%', '80%'],
                labelLine: {
                  smooth: true
                },
                data: res.data.data
              }]
            }
            this.chart = Chart.init(this.$refs.yongtu)
            this.chart.setOption(option)
          }
        })



      }

    }
  }
</script>

<style>
  .map {
    height: 600px;
  }

  .titem {
    flex: 1;
  }

  .tongji {
    display: flex;
  }

  .titem {
    flex: 1;
    height: 100px;
    background: url('../../assets/img/ibg.png');
    background-size: 100% 100%;
    text-align: center;
  }

  .titem p {
    color: #fff;
    font-size: 12px;
    margin-top: 27px;
  }

  .tdata {
    color: #01D4F9;
    font-size: 14px;

  }

  .titem:first-child {
    margin-right: 10px;
  }

  .cleft {
    padding-top: 24px;
  }

  .chongzhi,
  .meiyue {
    padding: 10px 10px;
    margin-bottom: 20px;
  }

  .rili {
    margin-top: 20px;
    padding: 20px 10px;
  }

  .riliBox {
    height: 300px;
    width: 100%;
    overflow: hidden;
    position: relative;
  }

  .riliBox .el-calendar__button-group {
    display: none;
  }

  .riliBox .el-button {
    background: #3D6BF1;
    color: #fff;
  }

  .riliBox .el-calendar__header {
    padding: 12px 0;
  }

  .riliBox .el-calendar-table .el-calendar-day {
    height: 30px !important;
  }

  .riliBox .el-calendar__title {
    font-size: 14px !important;
  }

  .riliBox .el-calendar-table {
    font-size: 14px !important;
  }

  .riliBox .el-calendar__body {
    padding: 0;
  }

  .riliBox .el-calendar__title {
    color: #fff;
  }

  .riliBox .el-calendar-table thead th {
    color: #fff;
  }

  .riliBox .el-backtop,
  .el-calendar-table td.is-today {
    background: #ccc;

  }

  .riliBox .el-calendar-table {
    color: #fff;
  }

  .riliBox .el-calendar-table:not(.is-range) td.next,
  .el-calendar-table:not(.is-range) td.prev {
    color: #2c3e50;
  }

  .riliBox .el-backtop,
  .el-calendar-table td.is-today {
    color: #fff;
  }

  .riliBox .el-calendar-table td.is-selected {
    background: #3D6BF1;
    color: #FFFFFF;
  }

  .riliBox .el-calendar-table td .el-calendar-day:hover {
    background: #3D6BF1 !important;
    color: #FFFFFF;

  }

  .riliBox .el-calendar {
    height: 100% !important;
    background: none !important;
  }

  .riliBox .el-calendar-table td {
    border-bottom: 1px solid #0A336D;
    border-right: 1px solid #0A336D;

  }

  .riliBox .el-calendar-table tr td:first-child {
    border-left: 1px solid #0A336D;
  }

  .riliBox .el-calendar-table tr:first-child td {
    border-top: 1px solid #0A336D;
  }

  .ctitle {
    color: #FFFFFF;
    height: 36px;
    line-height: 36px;
    font-size: 13px;
    padding-left: 10px;
    margin-bottom: 10px;
    background: linear-gradient(92deg, rgba(8, 37, 183, 1), rgba(1, 180, 255, 1));
  }

  .chbox {
    width: 100%;
    height: 210px;
  }

  .yongtu {
    position: relative;
    height: 240px;
    padding: 20px 10px;
  }

  .yongtu .switch {
    position: absolute;
    z-index: 99;
    left: 10px;
    top: 80px;
  }

  .cavasbox {
    box-sizing: border-box;
    width: 100%;
    height: 100%;
  }

  .scontainer {
    width: 100%;

    background: url('../../assets/img/index.jpg');
    background-size: cover
  }

  .header {
    display: flex;
    justify-content: space-between;
    color: #2AA7D3;
    font-size: 16px;
    line-height: 60px;
    position: relative;
    z-index: 99;

  }

  .header .date {
    display: flex;
  }

  .header .title {
    flex: 1;
    height: 60px;
    padding: 0 40px;
    text-align: center;
  }

  .title img {
    width: 85%;
  }

  .weather {
    text-align: center;
    padding-top: 0px;
    margin-right: 20px;
    margin-top: 10px;
  }

  #weather-v2-plugin-simple {
    line-height: 60px;
  }

  .date div {
    padding: 0 10px;
  }



  .dataList {
    display: flex;
    justify-content: center;
    margin-top: 30px;
  }

  .dataItem {
    width: 130px;
    height: 130px;
    margin: 10px;
    text-align: center;

  }

  .dataItem:nth-child(1) {
    background: url(../../assets/img/b1.png);
    background-size: 100% 100%;
  }

  .dataItem:nth-child(2) {
    background: url(../../assets/img/b2.png);
    background-size: 100% 100%;
  }

  .dataItem:nth-child(3) {
    background: url(../../assets/img/b3.png);
    background-size: 100% 100%;
  }

  .dataItem:nth-child(4) {
    background: url(../../assets/img/b4.png);
    background-size: 100% 100%;
  }

  .dataItem:nth-child(5) {
    background: url(../../assets/img/b5.png);
    background-size: 100% 100%;
  }

  .dataItem .img {
    padding-top: 20px;
  }

  .dataItem .num {
    font-size: 26px;
    padding: 6px 0;
  }

  .dataItem .img img {
    width: 24px;
  }

  .dataItem .title {
    color: #fff;
    font-size: 14px;
  }
</style>



// WEBPACK FOOTER //
// src/views/charts/summary.vue